export default {
    title_1: 'Read the F*ing directions',
    title_2: 'for',
    subtitle:
        '500,000 mail-in ballots were tossed during the 2024 elections. Make sure yours is counted.',
    election_banner_title: 'Election Day is November 3, 2026.',
    qualification_title: 'you can vote by mail if you',
    qualification_or_title: 'OR',
    military_title: 'Military and Overseas Voters',
    deadlines_title: 'Deadlines',
    postal_service_instructions_title: 'FYI: Changes at the Post Office',
    instructions_title: 'Instructions',
    share_title: 'Share',
    share_description: "Don't let your {0} friends f* this up",
    resources_title: 'Resources',
    video_title: 'Friendly Reminder',
    trust_title: 'Trust, but verify',
};
